export const createAction = (type, payload) => ({ type, payload });


// {} ye wali brakets block of code ko show krti ha or yai {} wali brakets object bananay k liye bhe use hoti hain. Is k solution main humain () ye wali beakets use karni hoti hain around the object ta k hum compiler ko bta sakain k ye block of code nai balky ak object ha